import React, { CSSProperties } from 'react'

import usePosthogCapture from '../../hooks/posthogCapture/usePosthogCapture'
import { useCompanyCompassLink } from '../../hooks/useCompanyCompassLink'
import CopyLink from '../misc/PanelInviteEmailTemplate/CopyLink'

interface Props {
  className?: string
  style?: CSSProperties
}

const CompanyCompassCopyLinkButton: React.FC<Props> = ({
  className,
  style,
}) => {
  const link = useCompanyCompassLink()
  const { posthogCapture } = usePosthogCapture()

  return (
    <CopyLink
      className={className}
      textToCopy={link}
      buttonText="Copy link"
      style={{ minWidth: '110px', ...style }}
      onClick={() =>
        posthogCapture({
          appArea: 'compass',
          action: 'global-link-copied',
        })
      }
    />
  )
}

export default CompanyCompassCopyLinkButton
